import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import ConfirmStone from "./confirm-stone"
import CustomizeOptions from "./customize-options"
import Progress from "./progress"

const InternalCustomizeStone = ({ currentStepName }) => {
  return (
    <Box>
      <Progress />
      {currentStepName === "confirm_stone" ? (
        <ConfirmStone />
      ) : (
        <CustomizeOptions />
      )}
    </Box>
  )
}

const mapStateToProps = (state) => {
  return {
    currentStepName: state.diamondUI.steps[state.diamondUI.currentStep],
  }
}

const mapDispatchToProps = () => {
  return {}
}

InternalCustomizeStone.propTypes = {
  currentStepName: PropTypes.string,
}

const CustomizeStone = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalCustomizeStone)

export default CustomizeStone
